import {all, select, takeLatest, put} from 'redux-saga/effects';

import {setBoxOption} from 'features/contacts/reducers/boxOption/boxOption';
import {
    fetchDiscountPrice,
    getFetchContactLensesPriceData,
} from 'features/contacts/reducers/discountPrice/discountPrice';
import {setFields} from 'features/contacts/reducers/prescriptionValues/prescriptionValues';
import {PRODUCT} from 'constants/actions';
import {isContactLenses as isContactLensesSelector} from 'selectors/product/product';
import {isProductPage} from 'selectors/routerInfo/routerInfo';
import {fetchReorderItem} from '../../../reorder/reducers/reorder/reorder';

/**
 * Request a new price each time when
 */
export function* requestPrice() {
    const [isContactLenses, isPDP] = yield all([
        select(isContactLensesSelector),
        select(isProductPage),
    ]);

    if (!isContactLenses || !isPDP) return;

    const priceData = yield select(getFetchContactLensesPriceData);
    yield put(fetchDiscountPrice(priceData));
}

/**
 * Root
 */
export function* priceSaga() {
    yield takeLatest(
        [
            `${setFields}`,
            `${setBoxOption}`,
            PRODUCT.SET_ACTIVE_PRODUCT_ID,
            `${fetchReorderItem}_FULFILLED`,
            `${fetchReorderItem}_REJECTED`,
        ],
        requestPrice,
    );
}
